import { render, staticRenderFns } from "./PixTransactionsContent.vue?vue&type=template&id=037a80a2"
import script from "./PixTransactionsContent.vue?vue&type=script&lang=js"
export * from "./PixTransactionsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports